(() => {
  if (customElements.get('cursor-loader')) {
    return;
  }

  class CursorLoader extends HTMLElement {
    static VISIBLE_CLASS = 'is-visible';
    static HIDDEN_CLASS = 'is-hidden';

    constructor() {
      super();

      this.onMouseMove = this.onMouseMove.bind(this);
      this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    attachEvents() {
      window.addEventListener('mousemove', this.onMouseMove, { passive: true });

      document.addEventListener('mouseleave', this.onMouseLeave, {
        passive: true,
      });
    }

    detachEvents() {
      window.removeEventListener('mousemove', this.onMouseMove);

      document.removeEventListener('mouseleave', this.onMouseLeave);
    }

    init() {
      this.frameDuration = 300;
      this.frames = [];
      this.mediaElement = this.querySelector('[data-image-container]');

      this.loadFrames();
    }

    async loadFrames() {
      const framesAttr = this.getAttribute('data-frames');

      if (!framesAttr) {
        console.error('CursorLoader: missing data-frames attribute');

        return;
      }

      this.frameUrls = JSON.parse(framesAttr);

      if (!Array.isArray(this.frameUrls) || this.frameUrls.length === 0) {
        console.warn(
          'CursorLoader: data-frames is not a valid non-empty array',
        );

        return;
      }

      const promises = this.frameUrls.map((url) => {
        const image = new Image();

        image.src = url;

        return new Promise((res, rej) => {
          image.onload = () => res(image);
          image.onerror = rej;
        });
      });

      this.frames = await Promise.all(promises);

      this.mediaElement.style.backgroundImage = `url(${this.frames[0].src})`;
    }

    startAnimation() {
      const startTime = performance.now();

      const loop = () => {
        const now = performance.now();
        const elapsed = now - startTime;
        const frameIndex =
          Math.floor(elapsed / this.frameDuration) % this.frames.length;

        if (this.frames.length > 0) {
          this.mediaElement.style.backgroundImage = `url(${this.frames[frameIndex].src})`;
        }

        this.animationFrameId = requestAnimationFrame(loop);
      };

      this.animationFrameId = requestAnimationFrame(loop);
    }

    stopAnimation() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);

        this.animationFrameId = null;
      }
    }

    onMouseMove = (event) => {
      this.classList.remove(CursorLoader.HIDDEN_CLASS);

      this.updatePosition(event.clientX, event.clientY);
    };

    onMouseLeave = () => {
      this.classList.add(CursorLoader.HIDDEN_CLASS);
    };

    updatePosition(cursorX, cursorY) {
      this.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0) translate(-50%, -50%)`;
    }

    show() {
      if (this.classList.contains(CursorLoader.VISIBLE_CLASS)) {
        return;
      }

      this.startAnimation();

      this.classList.add(CursorLoader.VISIBLE_CLASS);
    }

    hide() {
      this.stopAnimation();

      this.classList.remove(CursorLoader.VISIBLE_CLASS);
      this.classList.remove(CursorLoader.HIDDEN_CLASS);
    }
  }

  customElements.define('cursor-loader', CursorLoader);
})();
